
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ProjectFiles.html?raw';
import on from 'dojo/on';
import { EvBookingCopyForm } from "../../_loadingHelpers/VAMv2";
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import "../../../moreCore/UI/EntityBased/HintBox/HintBox"
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import FileUpload from '../../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
import FileUploadDisplay_ListRow from '../../../moreCore/UI/Filetransfer/FileUpload/FileUploadDisplay_ListRow/FileUploadDisplay_ListRow';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import Tooltip from '../../../moreCore/UI/Floating/Tooltip';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import ExpandableSection from '../../../moreCore/UI/Container/ExpandableSection';
import { ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import PageStack from '../../../moreCore/UI/Tabbing/PageStack';
import "../../../moreCore/UI/Tabbing/PageStack";
import filePreview from '../../filePreview/filePreview';
import { FileUploadTypes } from "../../../moreCore/UI/Filetransfer/FileUpload/FileUploadTypes";
import FileDownloadHandler from '../../../moreCore/UI/Filetransfer/FileDownloadHandler';
class ProjectFiles extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    pagestack: MdsLax<InstanceType<typeof PageStack>>;

    fileUpload: MdsLax<InstanceType<typeof FileUpload>>;

    filesTable: MdsLax<InstanceType<typeof StaticTable>>;
    filesTableContainer: HTMLElement;
    filesSectionContainer: MdsLax<InstanceType<typeof ExpandableSection>>;

    bookingFilesTable: MdsLax<InstanceType<typeof StaticTable>>;
    bookingFilesTableContainer: HTMLElement;

    newUploadFiles: any[] = [];
    private fileCategories: Array<{ ID: string, description: string }> = [];
    private fdh: MdsLax<InstanceType<typeof FileDownloadHandler>> = null;

    private existingFilesTableLayout: StaticTable.RowConfig = {
        "attributes": ["filename", "keyword", "ref_file_category.description", "ref_entity_1.$ClassPrintname"],
        colNamesInternal: ["filename", "keyword", "ref_file_category.description", "Source"],
        "headings": [(this as any).translations["General_Label_Filename"], (this as any).translations["General_Label_Keyword"], (this as any).translations["General_Label_Category"], (this as any).translations["General_Label_Source"]],
    }

    private table_formatterFunction(cell: StaticTable.StaticTableCell<object>): boolean {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;

        switch (colName) {
            case "Aktionen":
                //this.UiModder.domAttr.set(cell.tableCellNode, "nowrap", true)
                let icon = this.createFontawesomeIcon("fas fa-download hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._downloadFile, entity));

                let disabled = "";
                //if (!entity["ref_entity_1"] /*|| entity["ref_entity_1"]["ID"] !== this.currentData.ID*/) disabled = "w3-disabled";
                icon = this.createFontawesomeIcon(`fas fa-trash hoverTxtPrimary secondaryText warningTXT ${disabled}`, "", node);

                if (this.isReadonly()) {
                    this.disableNode(icon);
                } else {
                    on(icon, "click", lang.hitch(this, this._deleteFile, entity));
                }



                return true;
                break;

            case "Source":
                let sourceTooltip = new Tooltip();
                let fileEntity = entity as any;
                if (fileEntity && fileEntity.ref_entity_1) {
                    sourceTooltip.setup({
                        content: fileEntity.ref_entity_1?.$Displayname,
                        targetnode: node,
                        enableHover: true,
                        enableClick: true,
                        heading: value,
                        //_debugKeepOpen: 99999
                    });
                    node.innerHTML = this.createFontawesomeIcon("fas fa-info-circle", "&nbsp;").outerHTML + value;
                    return true;
                }
                else {
                    cell.value = null;
                    return false;
                }
                break;
        }

        return false;
    }

    private evBookingFiles_formatterFunction(cell: StaticTable.StaticTableCell<object>): boolean {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;

        switch (colName) {
            case "Aktionen":
                //this.UiModder.domAttr.set(cell.tableCellNode, "nowrap", true)
                let icon = this.createFontawesomeIcon("fas fa-download hoverTxtPrimary secondaryText w3-margin-right", "", node);
                on(icon, "click", lang.hitch(this, this._downloadFile, entity));

                return true;
                break;

            case "Source":
                let sourceTooltip = new Tooltip();
                let fileEntity = entity as any;
                if (fileEntity && fileEntity.ref_entity_1) {
                    sourceTooltip.setup({
                        content: fileEntity.ref_entity_1?.$Displayname,
                        targetnode: node,
                        enableHover: true,
                        enableClick: true,
                        heading: value
                    });
                    node.innerHTML = this.createFontawesomeIcon("fas fa-info-circle", "&nbsp;").outerHTML + value;
                    return true;
                }
                else {
                    cell.value = null;
                    return false;
                }
                break;
        }

        return false;
    }

    private _downloadFile(rowGrp: StaticTable.StaticTableRowGroup<VAM2types.VtFiles>): void {
        let file = rowGrp.entity;
        console.debug("_downloadFile", file);
        //window.open(window.appRoot + `EvBookingEditor/DownloadExistingFile?downloadKey=${file["ID"]}`)

        if (file.Classname) {
            if (this.hasFeature("filePreview", "useInProjectWizardV2") == false) {
                this.fdh = new FileDownloadHandler();
                this.fdh.downloadFromUrl(file["ID"]);
                //window.open(window.appRoot + `EvBookingEditor/DownloadExistingFile?downloadKey=${file["ID"]}`);
            } else {
                this.StandbyStart();
                let filePreviewWidget = new filePreview();
                filePreviewWidget.show(
                    { key: file.ID },
                    true,
                    true,
                    lang.hitch(this, () => {
                        this.StandbyStop();
                    }),
                    lang.hitch(this, () => {
                        this.showToast(this.translate("General_Error"), "fas fa-exclamation-triangle");
                        this.StandbyStop();
                    })
                );
            }
        } else {
            this.showToast(this.translate("General_Error_FileNotUploaded"), "fas fa-exclamation-triangle");
        }
    }


    private _deleteFile(rowGrp: StaticTable.StaticTableRowGroup<VAM2types.VtFiles>): void {
        let file = rowGrp.entity;
        if (this.isReadonly()) return;

        let deletedFile = this.currentData["existingFiles"].filter(x => x["ID"] == file["ID"])[0];
        if (deletedFile){
            deletedFile["state"] = "deleted"
        }

        this.drawTable(this.currentData["existingFiles"]);
        console.log("existingFiles", this.currentData["existingFiles"]);

        this.checkIsFormDirty();
    }

    private drawTable(data: any, type?: "project" | "booking"): void {

        var table: MdsLax<InstanceType<typeof StaticTable>>;
        var tableContainer: HTMLElement;
        var tableFormatterFunction: StaticTable.formatterCallback;
        let dlIcon = "fas fa-download";
        if (this.hasFeature("filePreview", "useInProjectWizardV2")) {
            dlIcon = "fas fa-search";
        }
        if (!type) type = "project";

        let list = data.filter(x => x["state"] != "deleted");

        if (type) {
            switch (type) {
                case "project":
                    this.filesTable = new StaticTable();
                    table = this.filesTable;
                    tableContainer = this.filesTableContainer;
                    tableFormatterFunction = lang.hitch(this, this.table_formatterFunction);

                    this.filesTable.addDefaultRowActionButton("delete", lang.hitch(this, this._deleteFile));//

                    table.enableActionButton("delete", null, false);// erst deaktivieren - wird asynchron mit privilege gemacht // lang.hitch(this, this._onCheckFileDeletable));
                    for (let entry of list) {
                        this.webPrivilegeManager.loadPrivilegesForEntity(entry, lang.hitch(this, this._onEntityPrivilegeReady, entry));
                    }


                    this.filesTable.addCustomRowActionButton("download", lang.hitch(this, this._downloadFile), dlIcon);
                    this.filesTable.setCyAttribute("ProjectFilesTable");
                    break;
                case "booking":
                    this.bookingFilesTable = new StaticTable();
                    table = this.bookingFilesTable;
                    tableContainer = this.bookingFilesTableContainer;
                    tableFormatterFunction = lang.hitch(this, this.evBookingFiles_formatterFunction);

                    this.bookingFilesTable.addCustomRowActionButton("download", lang.hitch(this, this._downloadFile), dlIcon);
                    table.setCyAttribute("ProjectFilesBookingFilesTable");
                    break;
                default:
                    console.error("Type not found");
                    break;
            }
        } else {
            this.filesTable = new StaticTable();
            table = this.filesTable;
            tableContainer = this.filesTableContainer;
            tableFormatterFunction = lang.hitch(this, this.table_formatterFunction);
            this.filesTable.setCyAttribute("ProjectFilesTable");
        }


        tableContainer.innerHTML = null;

        //if (table != null) table.destroy();
        //table = new StaticTable();

        table.setFormatter(tableFormatterFunction);
        table.addLineConfig(this.existingFilesTableLayout);

        this.UiModder.domConstruct.place(table.domNode, tableContainer);



        table.setData(list);

        let filesListProject = this.filesTable?.getData();
        let filesListBooking = this.bookingFilesTable?.getData();

        this.filesSectionContainer.setMarking((filesListProject?.length || filesListBooking?.length) ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);



    }
    private _onEntityPrivilegeReady(file: VAM2types.VtFiles) {
        //this.hasUserRole("Files_Delete", lang.hitch(this, this._onDeletePrivilege, file), file);

        //Need to pass all parameters because enableActionButton passes rowgroup as classnameAttribute
        this.filesTable.enableActionButton("delete", file, lang.hitch(this, this.hasUserRole, "Files_Delete", null, file, null, null) as any);
    }
    protected afterSetData() {
        let data = this.sourceData as VAM2types.EvProjectEntity_Extended;

        //this.setStartupState("loading");

        this.resetFileUploadInput();


        this.drawTable(data ? data.existingFiles ? data.existingFiles : [] : [], "project");
        this.drawTable(data ? data.bookingFiles ? data.bookingFiles : [] : [], "booking");
        this.resetDirty();

        this.pagestack.activatePageByName("files_default");

        let filesListProject = this.filesTable?.getData();
        let filesListBooking = this.bookingFilesTable?.getData();

        this.pagestack.disablePage("files_default", filesListProject?.length ? false : true);
        this.pagestack.disablePage("files_ev_bookings", filesListBooking?.length ? false : true);

    }

    private resetFileUploadInput() {

        this.fileUpload.resetFileUpload();
        this.newUploadFiles = [];
    }

    protected onDirtyChange(currentState: boolean) {

    }

    protected onSetReadOnly(isReadonly: boolean) {
        if (isReadonly === true) {
            this.pagestack.disablePage("upload", isReadonly);
        }
        let data = this.sourceData as VAM2types.EvProjectEntity_Extended;
        if (data) {
            this.drawTable(data.existingFiles);
        }
    }

    protected _onChanged(key: string, value: any) {
        //this.setStylesBasedOnData(); // bissl extrem? wird bei jeder kleinen Änderung aufgerufen
    }

    private _onChangeUploadFile(guid) {

        if (this.isReadonly()) return;

        let newFilesArr = this.fileUpload.getValue();

        if (newFilesArr && this.fileUpload.validateInput()) {

            if (this.newUploadFiles.length === 0) {
                this.newUploadFiles = newFilesArr;
                this.newUploadFiles.forEach(file => {

                    this.addDefaultCategoryToFile(file);
                });

                this.currentData["newUploadFiles"] = this.newUploadFiles;
                console.debug("newUploadFiles", this.currentData["newUploadFiles"]);

                this.checkIsFormDirty();

                return;
            }

            newFilesArr.forEach(file => {

                let guid = file.guid;
                let fileNames = file.filenames
                let existingFile = this.newUploadFiles.filter(x => x["guid"] === guid)[0];

                if (!existingFile) {

                    this.addDefaultCategoryToFile(file);

                    this.newUploadFiles.push(file);
                } else {
                    if (existingFile && existingFile["fileCategories"] && existingFile["fileCategories"].length > fileNames.length) {

                        let catToDelete = existingFile["filenames"].filter(x => fileNames.indexOf(x) === -1);

                        if (catToDelete) existingFile["fileCategories"].splice(existingFile["fileCategories"].indexOf(existingFile["fileCategories"].filter(x => x["fileName"] === catToDelete)[0]), 1);
                    }

                    if (!existingFile["fileCategories"] || existingFile["fileCategories"].length == 0) {

                        this.addDefaultCategoryToFile(existingFile);
                    }
                }
            });

            this.currentData["newUploadFiles"] = this.newUploadFiles;
        } else {

            this.newUploadFiles = [];
            delete this.currentData["newUploadFiles"];
        }

        this.checkIsFormDirty();

        console.debug("newUploadFiles", this.currentData["newUploadFiles"]);
    }
    checkIsFormDirty(): boolean {

        console.debug(this.id + " dirty check ORIGINAL DATA", this.sourceData);
        console.debug(this.id + " dirty check CURRENT DATA", this.currentData);

        return this.isDirty(true);

    }

    private addDefaultCategoryToFile(file: { guid: string, filenames: string[] }): void {

        var defaultCategory = this.fileCategories[0].ID;
        file["fileCategories"] = [];
        file["filenames"].forEach(fileName => {
            file["fileCategories"].push({
                category: defaultCategory,
                fileName: fileName,
            });
        });
    }

    private _loadFileCategoriesList(): void {

        let requestUrl = window.appRoot + "ProjectWizard/GetFileCategoriesList";

        this.RequestManager.post(
            requestUrl,
            {
                jsonData: null
            },
            (response: any) => { this.fileCategories = response },
            (err: any) => { alert(err.Message) },
            false // sync
        );
    }

    protected setupSelectBoxInFileRow(evt: { name: string, row: MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>> }): void {
        let fileRow = evt.row;
        //console.debug("fileRow", fileRow);
        let selectBox = new SearchSelect();

        selectBox.labelAttribute = "description";
        selectBox.setLabel(this.translations["General_Label_Category"]);
        selectBox.setMandatory(true);
        selectBox.setSelectionListLEGACY(this.fileCategories);

        let categoryToSet = this.fileCategories[0].ID;

        let newFilesArray: Array<any> = this.currentData["newUploadFiles"];

        if (newFilesArray?.length) {
            newFilesArray.forEach(file => {

                if (file["guid"] === fileRow.getData()["uploadGUID"]) {

                    if (file["fileCategories"]) categoryToSet = file["fileCategories"].filter(x => x["fileName"] === fileRow.getData()["FileName"])[0]["category"];
            }
        });
        }

        selectBox.setValue(categoryToSet, true);

        selectBox.on("change", lang.hitch(this, this._onChange_FileCategory, fileRow, selectBox.getValue()));

        fileRow.addContent_LEGACY(true, selectBox.domNode);
    }

    private _onChange_FileCategory(fileRow: MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>, value: string): void {
        let rowData = fileRow.getData();
        let rowFileGuid = rowData["uploadGUID"];
        let rowFileName = rowData["FileName"];
        let fileToSave = this.currentData["newUploadFiles"].filter(x => x["guid"] === rowFileGuid)[0];

        //if (fileToSave) fileToSave["fileCategoryID"] = value;
        if (fileToSave) fileToSave["fileCategories"].filter(x => x["fileName"] === rowFileName)[0]["category"] = value;

        console.debug("newUploadFiles", this.currentData["newUploadFiles"]);
    }


    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        if (this.hasFeature("EvProject/FileManage")) {
            this.fileUpload.on("NewRowCreated", lang.hitch(this, this.setupSelectBoxInFileRow));
            this._loadFileCategoriesList();

            this.pagestack.showPage("upload");
            this.pagestack.disablePage("upload", this.isReadonly());
        }

        this.fileUpload.on("fileRemoved", lang.hitch(this, (removedFile:FileUploadTypes.UploadDescriptor)=>{
            //entferne files rausfiltern
            this.currentData.newUploadFiles = (this.currentData?.newUploadFiles ?? []).filter((elem) => {
                return elem.guid != removedFile.uploadGUID;
            });
            this.emit("dirty", true); //damit aenderungen auch wirklich nach uebernommen werden im root widget
        }));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);


    }
}

export default mdsWidget(ProjectFiles);
